angular.module('bribac.entities.ruleSetFactory', [])

  .value('ruleSetFactory', function ruleSetFactory(data) {
    return angular.merge({
      id: null,
      template: false,
      name: null,
      testExpiresAfterSeconds: null,
      deleteTestDataAfterDays: null,
      // Geo-fence isn't supported in the API yet.
      geoFence: null,
      // geoFence: {
      //   latitude: null,
      //   longitude: null
      // },
      bacLimit: {},
      showResults: null,
      notifyPassed: null,
      notifyFailed: null,
      notifyExpired: null,
      notifyFailedOptional: null,
      notifyPassedOptional: null,
      requireGpsLocation: false
    }, data)
  })
